export enum UsageType {
  ENERGY = 'energy',
  WATER = 'water',
}
